export const PRIMARY_COLOR = getEnv("PRIMARY_COLOR", "#076322");
export const SECONDARY_COLOR = getEnv("SECONDARY_COLOR", "#19857b");
export const HABILITA_CABECALHO = getEnv("HABILITA_CABECALHO", "S");
export const AMBIENTE = getEnv("AMBIENTE", "");
export const HABILITA_MASSA_MOCKADA =
    String(getEnv("HABILITA_MASSA_MOCKADA", "N")).toUpperCase() === "S";
export const NOME_APP = getEnv("NOME_APP", "Conector e-Sfinge");
export const PUBLIC_BASE_PATH = normalizeBasePath(
    getEnv("PUBLIC_BASE_PATH", process.env.PUBLIC_URL || "")
);
export const CONECTOR_ESFINGE_URL = getEnv(
    "CONECTOR_ESFINGE_URL",
    "http://localhost:8081/dpge-integracao-esfinge/"
);
export const KEYCLOAK_URL = getEnv("KEYCLOAK_URL", "");
export const KEYCLOAK_REALM = getEnv("KEYCLOAK_REALM", "");
export const KEYCLOAK_CLIENT_ID = getEnv("KEYCLOAK_CLIENT_ID", "");
export const KEYCLOAK_ROLE_MASTER = getEnv(
    "KEYCLOAK_ROLE_MASTER",
    "ESFINGE_MASTER"
);
export const KEYCLOAK_ROLE_FOLHA = getEnv(
    "KEYCLOAK_ROLE_FOLHA",
    "ESFINGE_FOLHA"
);
export const KEYCLOAK_ROLE_FINANCEIRA = getEnv(
    "KEYCLOAK_ROLE_FINANCEIRA",
    "ESFINGE_FINANCEIRA"
);
export const GESTAO_FISCAL_ENVIO_HOMOLOGACAO_ENABLED =
    String(
        getEnv(
            "INTEGRACAO_FINANCEIRA_GESTAO_FISCAL_ENVIO_HOMOLOGACAO_ENABLED",
            "false"
        )
    ).toLowerCase() === "true";

function getEnv(envName, defaultValue) {
    if (!window.env) {
        window.env = {};
    }

    if (window.env[envName] == null) {
        window.env[envName] = defaultValue;
    }

    return window.env[envName];
}

function normalizeBasePath(value) {
    if (typeof value !== "string" || !value || value === "/") {
        return "";
    }

    const basePath = value.startsWith("/") ? value : `/${value}`;
    if (!/^\/(?:[a-zA-Z0-9_-]+\/?)+$/.test(basePath)) return "";
    return basePath.endsWith("/") ? basePath.slice(0, -1) : basePath;
}
